import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official';
import { Header } from '../Header';
import { Footer } from '../Footer';

export default class ReportViewer extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: 1,
            controllerName: 'report',
            data: null,
            loading: true,
            per_page: 30,
            page: 1
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
        this.state.per_page = 30;
        this.state.page = 1;
        this.state.filters = {
            id: this.getCurrentFormId(),
            page: 1,
            count: 30,
            phrase: '',
            format: ''
        }
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.refreshData(null, "viewer");
    }
    componentDidUpdate() {
        if (this.getCurrentFormId() === this.state.filters.id) return;
        this.state.filters = {
            id: this.getCurrentFormId(),
            page: 1,
            count: 30,
            phrase: '',
            format: ''
        }
        this.state.per_page = 30;
        this.state.page = 1;
        this.refreshData(null, "viewer");
    }
    handlePageChange(page) {
        this.state.page = page;
        this.state.filters.page = page;
        this.refreshData(null, "viewer");
    }
    handlePerRowsChange(newPerPage) {
        this.state.page = 1;
        this.state.filters.page = 1;
        this.state.per_page = newPerPage;
        this.state.filters.count = newPerPage;
        this.refreshData(null, "viewer");
    }
    getData() {
        return JSON.parse(this.state.data.records);
    }
    exportReportResualt(format = 'pdf') {
        this.setState({ loading: true });

        this.httpPost("api/v1/report/viewer", {
            filters: {
                id: this.state.filters.id,
                page: this.state.filters.page,
                count: this.state.filters.count,
                phrase: this.state.filters.phrase,
                format: format
            }
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    if (format == 'pdf') this.downloadPDF(data.bs64);
                    if (format == 'excel') this.downloadExcel(data.bs64);
                    if (format == 'print') this.state.printBs64 = data.bs64;
                    this.setState({
                        loading: false
                    })
                }
                else {
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    getChartSeries() {
        const data = this.getData();
        if (!data || data.length === 0) return [];

        const xColumn = this.state.data.groupBy || [];
        const yColumns = this.state.data.fields || []

        const series = yColumns.map(yCol => ({
            name: yCol.alias,
            data: data.map(row => [
                (row[yCol.name] ? row[yCol.name] : row[yCol.name + "_Display"]),
                row[xColumn + "_agg"]
            ])
        }));
        console.log(series);
        return series;
    }
    renderForm() {
        return <div>
            <div className="nk-content-body">
                <div className="nk-block">
                    <div className="card card-bordered card-stretch">
                        <div className="card-inner-group">
                            {this.state.data.reportType === 1 && <div className="card-inner position-relative card-tools-toggle">
                                <div className="card-title-group">
                                    <form className="card-tools" mthod="post" onSubmit={e => this.refreshData(e)}>
                                        <p className="nk-block-title page-title">گزارش {this.state.data.reportTitle} <b>({this.money(this.state.data.recordsCount)} مورد)</b></p>
                                        <div className="form-inline flex-nowrap gx-3">
                                            <div className="btn-wrap">
                                                <span className="d-none d-md-block"><button onClick={e => this.exportReportResualt('print')} type="submit" className="btn btn-sm btn-primary hand"><em className="icon ni ni-printer"></em> چاپ نتایج</button></span>
                                            </div>
                                            <div className="btn-wrap">
                                                <span className="d-none d-md-block"><button onClick={e => this.exportReportResualt('pdf')} type="submit" className="btn btn-sm btn-danger hand"><em className="icon ni ni-file-pdf"></em> دریافت PDF نتایج</button></span>
                                            </div>
                                            <div className="btn-wrap">
                                                <span className="d-none d-md-block"><button onClick={e => this.exportReportResualt('excel')} type="submit" className="btn btn-sm btn-success hand"><em className="icon ni ni-file-xls"></em> دریافت اکسل نتایج</button></span>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>}

                            <div className="card-inner p-0">
                                {this.state.data.reportType === 1 && <div>
                                    {this.state.data.recordsCount <= 0 ?
                                        <div className="card-inner-group">
                                            <div className="example-alert">
                                                <div className="alert alert-pro alert-warning">
                                                    <div className="alert-text">
                                                        <h6>توجه</h6>
                                                        <p>هیچ نتیجه ای یافت نشد</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        :
                                        <div className="nk-tb-list nk-tb-ulist">
                                            <div className="nk-tb-item nk-tb-head">
                                                {this.state.data.fields.map(f => <div className="nk-tb-col text-center"><span className="sub-text">{f.alias}</span></div>)}
                                            </div>
                                            {this.getData().map((record, index) =>
                                                <div className="nk-tb-item">
                                                    {this.state.data.fields.map(f =>
                                                        <div className="nk-tb-col">
                                                            {record[f.alias] ?
                                                                <span className="sub-text text-center">{record[f.alias]}</span>
                                                                :
                                                                <span className="sub-text text-center">{record[f.alias + "_Display"]}</span>
                                                            }
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    }
                                </div>}
                                {this.state.data.reportType === 2 && <HighchartsReact
                                    highcharts={Highcharts}
                                    options={{
                                        title: {
                                            text: this.state.data.reportTitle
                                        },
                                        chart: {
                                            type: 'pie'
                                        },
                                        series: [{
                                            name: 'تعداد',
                                            data: this.getChartSeries()
                                        }],
                                        plotOptions: {
                                            pie: {
                                                allowPointSelect: true,
                                                cursor: 'pointer',
                                                dataLabels: {
                                                    enabled: true,
                                                }
                                            }
                                        }
                                    }
                                    }
                                />}
                                {this.state.data.reportType === 3 && <HighchartsReact
                                    highcharts={Highcharts}
                                    options={{
                                        title: {
                                            text: this.state.data.reportTitle
                                        },
                                        chart: {
                                            type: 'bar'
                                        },
                                        series: this.getChartSeries(),
                                        xAxis: {
                                            title: {
                                                text: ''
                                            },
                                            type: 'category',
                                        },
                                        yAxis: {
                                            title: {
                                                text: ''
                                            },
                                        },
                                    }
                                    }
                                />}
                                {this.state.data.reportType === 4 && <HighchartsReact
                                    highcharts={Highcharts}
                                    options={{
                                        title: {
                                            text: this.state.data.reportTitle
                                        },
                                        chart: {
                                            type: 'line'
                                        },
                                        series: this.getChartSeries(),
                                        xAxis: {
                                            title: {
                                                text: ''
                                            },
                                            type: 'category',
                                        },
                                        yAxis: {
                                            title: {
                                                text: ''
                                            },
                                        },
                                    }
                                    }
                                />}
                            </div>
                            {this.state.data.reportType === 1 && this.createPaging()}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.isEmpty(this.state.data.global.companies) ? this.renderNoCompanyRegister() : this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />,
                this.renderPopupComponent(),
            ];

        return contents;
    }
}